export default {
  enterprise: {
    title: "法人",
  },
  login: {
    title: "ログイン",
    user_id: "ユーザーID",
    password: "パスワード",
    enterprise: {
      title: "法人ログイン",
      id: "法人ID",
      remember_me: "ログイン状態を維持する",
      remember_ids: "法人ID、ユーザーIDを記憶する",
      forget_password:
        "パスワードをお忘れの方は、担当者へお問い合わせください。",
    },
  },
  SideMenu: {
    Dashboard: "ダッシュボード",
    Tool: "ツール",
    Management: "管理",
    Plots: "プロット",
    Maps: "マップ",
    VoyageHistories: "航海記録",
    Logout: "ログアウト",
    Enterprise: {
      Users: "社員管理",
      Crews: "労務管理",
      Vessels: "船舶管理",
      Destinations: "目的地管理",
      Camera: "カメラ管理",
      VesselNoonReport: "動静連絡",
      Notification: "お知らせ",
      VesselMonitoringEngine: "機関データ",
      Addons: {
        PortManagement: "入出港管理",
        PortMaster: "Port Master",
        VesselReport: "船舶動静連絡",
        ReportList: "一覧",
        VesselReportExport: "集計",
        EcoShip: "EcoShip",
        TankLiquidLevel: "タンク液位管理",
        RoutePlan: "航路計画管理",
        EcoShipContainer: "リーファーコンテナ管理",
        SecureDataflow: {
          header: "監視",
          monitoringVesselManeuvering: "操船監視",
        },
        FuelConsumption: "燃料消費量",
        FuelConsumptionMonthlyFuelReport: "燃料消費量(月次レポート)",
        FuelConsumptionYearlyFuelReport: "燃料消費量(統計レポート)",
        Utility: "ユーティリティ",
        HullInsrance: "損害対応",
        VesselPerformance: "船舶性能",
        FuelConsumptionReport: "省エネレポート",
        Operation: "運航管理",
        CrewOperator: "運航船労務管理",
        OperationList: "レポート一覧",
        CrewManagement: "船員管理",
        CrewAssignmentManagement: "配乗管理",
      },
    },
    Marina: {
      Users: "所属ユーザー管理",
    },
  },
  Views: {
    Commons: {
      DataTime: "日時",
    },
    Vessel: {
      Info: "船舶情報",
      AisTitle: "AIS情報",
      SizeTitle: "サイズ情報",
      Name: "船名(英)",
      NameJa: "船名",
      Category: "船種",
      Country: "国籍",
      CertificateNumber: "船舶番号",
      IdentificationNumber: "識別番号",
      GrossTonnage: "総トン数",
      LengthOverall: "全長",
      Width: "全幅",
      Draft: "喫水",
      FullDraft: "満載喫水",
      Status: "運航状態",
      LastReceived: "最終受信",
      Heading: "方位",
      Direction: "方位",
      Velocity: "速力",
      Latitude: "緯度",
      Longitude: "経度",
      Geo: "緯度経度",
      IMO: "IMO",
      MMSI: "MMSI",
      CallSign: "Call Sign",
      DimBow: "DimBow",
      DimStern: "DimStern",
      DimStarboard: "DimStarboard",
      DimPort: "DimPort",
      Destination: "目的地",
      ETA: "ETA",
      WakeLine: "航跡",
      TrackimoId: "ID",
      Kinds: "種別",
      Battery: "バッテリー",
    },
    Crew: {
      captain: "船長",
      chief_officer: "一等航海士",
      second_officer: "二等航海士",
      third_officer: "三等航海士",
      boatswain: "甲板長",
      able_seaman: "甲板手",
      ordinary_seaman: "甲板員",
      chief_engineer: "機関長",
      first_engineer: "一等機関士",
      second_engineer: "二等機関士",
      third_engineer: "三等機関士",
      machinist: "操機長",
      oiler: "操機手",
      wiper: "機関員",
      chief_radio_operator: "通信長",
      purser: "事務長",
      clerk: "事務員",
      chief_steward: "司厨長",
      steward: "司厨手",
      messman: "司厨員",
      chief_cook: "調理士",
      second_cook: "調理員",
      doctor: "船医",
      nurse: "看護師",
      other: "その他",

      "Ro-Ro Ship": "RORO船",
      "Oil Tanker": "油送船",
      "General Cargo": "一般貨物船",
      "Container Ship": "コンテナ船",
      "Chemical Tanker": "ケミカル船",
      PCC: "自動車専用船",
      "LPG Tanker": "LPG船",
      "LNG Tanker": "LNG船",
      "Cement Tanker": "セメント専用船",
      "Passenger Ship": "旅客船",
      "Pusher Barge": "プッシャーバージ",
      "Limestone Carrier": "石灰石専用船",
      Tug: "タグボート",
      "Other type": "その他",
      Drillship: "海底掘削船",
      "Seabed Explorer": "海洋資源探査船",
      LaborRecord: {
        Tasks: {
          on_duty: "当直",
          take_over_on_duty: "当直引継",
          cargo_handling: "荷役",
          departure_and_arrival: "出入港",
          maintenance: "保守",
          work_while_moored: "停泊中作業",
          food_service: "供食",
          emergency_station_drill: "操練等",
          training: "研修",
          safe_temporary_work: "安全臨時労働",
          urgent_work: "緊急作業（救助等）",
          tank_cleaning: "タンク清掃",
          hold_cleaning: "ホールド清掃",
          refueling: "補油作業",
          shopping: "買出し",
          rest: "休憩",
          others: "その他（事務等）",
        },
      },
    },
    Operation: {
      Report: {
        All: "全てのレポート",
        Download: "ダウンロード",
        Apply: "適用",
        withImage: "添付あり",
        withoutImage: "添付なし",
      },
      Situation: {
        IN_PROGRESS: "要対応",
        WAITING: "対応待ち",
        COMPLETE: "完了",
      },
      Error: {
        SystemError: {
          title: "システムエラー",
          text:
            "予期しないエラーが発生しました。時間を空けてもう一度試みてください",
        },
        NotFoundError: {
          title: "該当データが存在しません",
        },
      },
      Download: {
        Dialog: {
          title: "ダウンロード",
          confirmText: "ダウンロードを実行しますか？",
          acceptText: "実行",
          cancelText: "キャンセル",
        },
      },
      Delete: {
        Dialog: {
          title: "レポート情報削除",
          confirmText: "レポートを削除しますか？ 削除したデータは戻せません",
          acceptText: "実行",
          cancelText: "キャンセル",
        },
        Success: {
          text: "削除しました",
        },
        Fail: {
          text: "削除に失敗しました",
        },
      },
      Transaction: {
        Success: {
          text: "{transactionLabel}が完了しました",
        },
        Fail: {
          text: "{transactionLabel}に失敗しました",
        },
      },
      Edit: {
        Update: {
          Button: {
            text: "保存",
          },
        },
        Cancel: {
          Button: {
            text: "キャンセル",
          },
        },
        Success: {
          text: "@:Views.Operation.Edit.Update.Button.textが完了しました",
        },
        Fail: {
          text: "@:Views.Operation.Edit.Update.Button.textに失敗しました",
        },
      },
      ImageManipulation: {
        Preview: {
          label: "プレビュー",
        },
        Download: {
          label: "ダウンロード",
          Fail: {
            text: "ダウンロードに失敗しました",
          },
        },
        Delete: {
          label: "削除",
        },
        Read: {
          Fail: {
            text: "画像の取得に失敗",
          },
        },
      },
    },
  },

  // PageじゃなくViews配下に追加してね ＊削除予定
  Page: {
    PlaceHolder: {
      Search: "検索",
    },
    Vessel: {
      VesselTitle: "船舶情報",
      AisTitle: "AIS情報",
      SizeTitle: "サイズ情報",
      Name: "名前",
      NameJa: "名前",
      Category: "船種",
      Country: "国籍",
      CertificateNumber: "船舶番号/漁船登録番号",
      IdentificationNumber: "船体識別番号",
      Status: "状態",
      ReceivedTime: "受信日時",
      Heading: "船首",
      Direction: "方位",
      Velocity: "速度",
      Latitude: "緯度",
      Longitude: "経度",
      Geo: "緯度経度",
      Imo: "IMO",
      Mmsi: "MMSI",
      CallSign: "Call Sign",
      LengthOverall: "全長",
      Width: "横幅",
      DimBow: "DimBow",
      DimStern: "DimStern",
      DimStarboard: "DimStarboard",
      DimPort: "DimPort",
      FullDraft: "満載喫水",
    },
    Search: "検索",
  },
};
